module.exports = __webpack_public_path__ + "img/press-14.53738834.jpg";